export const FeedEvent = Object.freeze({
  ENABLE_FEED_SCROLLING: "enable_feed_scrolling",
  DISABLE_FEED_SCROLLING: "disable_feed_scrolling",
  FEED_PAN_START: "feed_pan_start",
  FEED_PAN_END: "feed_pan_end",
});
